/*
 * @Author: yuanweijiang
 * @Date: 2023-11-21 14:57:17
 * @LastEditors: yuanweijiang
 */
import axios from 'axios'
import store from '@/store'
import router from '@/router' // 引入 router
import { Message, Loading } from 'element-ui'

// let url = location.href;
// let baseUrl = url.substring(0, url.lastIndexOf("/"));
// 初始化配置
let config = {
    baseURL: process.env.VUE_APP_API_PRE,
    withCredentials: false
}
let instance = axios.create(config)
let startTime = null // 记录请求发送的时间戳
let endTime = null
let getTime = null
let loadingInstance = null
const originalXHROpen = XMLHttpRequest.prototype.open
const originalXHRSend = XMLHttpRequest.prototype.send
XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this._url = url
    this._method = method
    return originalXHROpen.call(this, method, url, ...args)
}

XMLHttpRequest.prototype.send = function (...args) {
    if (this._url && this._url.includes('/file/proxy')) {
        // 添加token到请求头
        const token = store.state.user.token
        if (token) {
            this.setRequestHeader('Authorization', 'Bearer ' + token)
        }
    }
    return originalXHRSend.call(this, ...args)
}

// Fetch 拦截
const originalFetch = window.fetch

window.fetch = async function (...args) {
    const [resource, config = {}] = args

    // 获取 URL
    const url = resource instanceof Request ? resource.url : resource

    // 检查是否需要添加 token
    if (url && url.includes('/file/proxy')) {
        const token = store.state.user.token
        if (token) {
            // 创建新的配置对象
            const newConfig = {
                ...config,
                headers: {
                    ...(config.headers || {}),
                    Authorization: `Bearer ${token}`
                }
            }

            // 如果 resource 是 Request 对象，创建新的 Request
            if (resource instanceof Request) {
                const newRequest = new Request(resource, newConfig)
                return originalFetch(newRequest)
            }

            return originalFetch(resource, newConfig)
        }
    }

    return originalFetch(resource, config)
}

// 添加请求拦截器
instance.interceptors.request.use(
    function (config) {
        let accessToken = store.state.user.token
        if (config.headers.Authorization != 'Basic Z2VuOmdlbg==') {
            if (accessToken) {
                config.headers.Authorization = 'Bearer ' + accessToken
            }
        }
        // 请求初始化配置
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)
// 添加响应拦截器
// 添加响应拦截器
instance.interceptors.response.use(
    (response) => {
        let data = response.data
        if (data.code == 0 || data.code == 200 || data.access_token) {
            return data || {}
        } else if (data.code == '100004') {
            Message.warning('请登录账号')
            return Promise.reject(response.data)
        } else {
            Message.warning(data.msg)
            return Promise.reject(response.data)
        }
    },
    (error) => {
        let customError = new Error()
        if (error.response && error.response.status === 424) {
            // 清空用户信息
            Message.warning('请求令牌已过期')
            customError.message = '请求令牌已过期'
            localStorage.clear()
            const ssoLoginUrl = '/authapi/auth/oauth2/authorize'
            const redirectUri = encodeURIComponent(window.location.origin + '/sso')
            const ssoUrl = `${ssoLoginUrl}?scope=server&redirect_uri=${redirectUri}&response_type=code&client_id=aidesign`
            window.location.href = ssoUrl
            return Promise.reject(customError)
        }
        if (error.code === 'ECONNABORTED') {
            customError.message = '网络请求超时!'
        } else if (error.response?.data?.msg) {
            customError.message = error.response.data.msg
        } else if (error.request && error.request.status == 0) {
            customError.message = '网络异常!'
        } else if (error.response) {
            customError.message = '网络请求错误:' + error.response.status
        } else {
            customError.message = '网络请求错误'
        }
        // 将原始错误信息保留，以便调试
        customError.originalError = error
        Message.error(customError.message)
        return Promise.reject(customError)
    }
)
const request = (url, method, params = {}, config = {}) => {
    return new Promise((resolve, reject) => {
        startTime = new Date().getTime()
        let loadingTimeout = setTimeout(() => {
            if (!window.noLoading) {
                loadingInstance = Loading.service({ target: config.target, background: 'rgba(0, 0, 0, 0.2)' })
            }
        }, 200)
        instance[method](
            url,
            ['get', 'GET', 'delete', 'DELETE'].includes(method)
                ? {
                      params,
                      ...config,
                      paramsSerializer: function (params) {
                          return Object.keys(params)
                              .map(function (key) {
                                  return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
                              })
                              .join('&')
                      }
                  }
                : params,
            { ...config }
        )
            .then((response) => {
                if (response.code == 0 || response.code == 200 || response.access_token) {
                    resolve(Object.keys(response).find((key) => key === 'data') ? response.data : response)
                } else {
                    reject(response)
                }
            })
            .catch((error) => {
                reject(error)
            })
            .finally(() => {
                endTime = new Date().getTime() // 获取请求结束的时间
                getTime = endTime - startTime
                if (getTime > 200 && loadingInstance) {
                    loadingInstance.close()
                }
                clearTimeout(loadingTimeout)
            })
    })
}

export default request
